import * as React from "react";

function WishlistOverwritePopup(props: {
	wishlistPrefillUrl: string
}) {
	const dialogElement = React.useRef(null);
	React.useEffect(() => {
		openPopup();
	}, []);

	function closePopup() {
		dialogElement.current.close();
	}

	function openPopup() {
		dialogElement.current.showModal();
	}

	return (
		<dialog ref={dialogElement} className="c-dialog js-wishlist-popup" data-test="wishlist-popup">
			<div className="c-dialog__content">
				<h1 className="c-card__title u-mb20">Wishlist already exists</h1>
				<p className="c-cms u-mb20">It looks like you have some items in your wishlist already. Would you like to add the items that were shared with you into your existing wishlist, or overwrite your existing wishlist and replace it with this one?</p>
				<div className="c-dialog__actions">
					<a className="c-button" data-test="wishlist-popup-add-button" href={props.wishlistPrefillUrl}>Add to existing wishlist</a>
					<a className="c-button c-button--outline" data-test="wishlist-popup-overwrite-button" href={props.wishlistPrefillUrl + '&clear=true'}>Overwrite existing wishlist</a>
				</div>
			</div>
			<button className="c-dialog__close" type="button" data-test="wishlist-popup-close-button" onClick={closePopup}><span className="u-visuallyhidden">Close overlay</span></button>
		</dialog>
	)
}
export default WishlistOverwritePopup;
